$(function () {

    /*media hub selectors in filter*/
    if ($('.chosen-select').length > 0) {
        $(".chosen-select").chosen({disable_search_threshold: 100});
        $('.chosen-select').on('touchstart', function(e){
            e.stopPropagation(); e.preventDefault();
            // Trigger the mousedown event.
            $(this).trigger('mousedown');
        });
    }

    /*media hub yellow panel button in filter -mobile version - */
    $('.filter_section_button_mobile a').click(function () {
        $(this).closest('.filter_section_button_mobile').toggleClass('close_view_btn').next().toggleClass('close_view');

    });
    /*solve problem with $.zIndex*/
    $.zIndex = $.fn.zIndex = function (opt) {
        var def = {inc: 10, group: "*"};
        $.extend(def, opt);
        var zmax = 0;
        $(def.group).each(function () {
            var cur = parseInt($(this).css('z-index'));
            zmax = cur > zmax ? cur : zmax;
        });
        if (!this.jquery)
            return zmax;

        return this.each(function () {
            zmax += def.inc;
            $(this).css("z-index", zmax);
        });
    }

    /*media hub datepicker*/
    // Block autokeyboard for datepickers on mobiles and tablets
    if (/iP(ad|od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
        $("#from").prop('readonly', true);
        $("#to").prop('readonly', true);
    }
    var dateFormat = "dd/mm/yy",
        from = $("#from").datepicker({
            defaultDate: "+1w",
            dateFormat: 'dd/mm/yy',
            showButtonPanel: true,
            numberOfMonths: 1,
            beforeShow: function (textbox, instance) {
                setTimeout(function () {
                    var buttonPane = $(textbox).datepicker("widget").find(".ui-datepicker-buttonpane");
                    buttonPane.append('<span onclick="$(\'#from\').datepicker(\'setDate\', null); $(\'#to\').datepicker(\'option\', \'minDate\', null);">Clear filter</span>');
                }, 1);

                instance.dpDiv.css({
                    marginLeft: 'auto'
                });
                $('#ui-datepicker-div').addClass('datepicker_hub');
                $('.ui-datepicker-current').hide();
            }
        }).on("change", function () {
            if (getDate(this)) {
                to.datepicker("option", "minDate", getDate(this));
            }
        }),
        to = $("#to").datepicker({
            defaultDate: "+1w",
            showButtonPanel: true,
            dateFormat: 'dd/mm/yy',
            numberOfMonths: 1,
            beforeShow: function (textbox, instance) {
                setTimeout(function () {
                    var buttonPane = $(textbox).datepicker("widget").find(".ui-datepicker-buttonpane");
                    buttonPane.append('<span onclick="$(\'#to\').datepicker(\'setDate\', null); $(\'#from\').datepicker(\'option\', \'maxDate\', null);">Clear filter</span>');
                }, 1);
                if ($(window).width() > 768) {
                    instance.dpDiv.css({
                        marginLeft: -(textbox.offsetWidth / 48 * (48 + 4)) + 'px'
                    });
                } else {
                    instance.dpDiv.css({
                        marginLeft: 'auto'
                    });
                }
                $('#ui-datepicker-div').addClass('datepicker_hub');
                $('.ui-datepicker-current').hide();
            }
        }).on("change", function () {
            if (getDate(this)) {
                from.datepicker("option", "maxDate", getDate(this));
            }
        });
        var strSelectedDate_1 = new Date($("#from").val());
        var strSelectedDate_2 = new Date($("#to").val());
        var formatedDate1 = $.datepicker.formatDate( "dd/mm/yy", strSelectedDate_1);
        var formatedDate2 = $.datepicker.formatDate( "dd/mm/yy", strSelectedDate_1);


    $(window).resize(function () {
        if ($(window).width() > 768) {
            from.datepicker("hide");
            from.blur();
            to.datepicker("hide");
            to.blur();
        }
        fixupHeaderPadding();
    });

    function getDate(element) {
        var date;
        try {
            date = $.datepicker.parseDate(dateFormat, element.value);
        } catch (error) {
            date = null;
        }
        return date;
    }

    /*media hub Search autocomplete*/
    $("#hub_search").autocomplete({
        source: "hub_json/search_example.json",
        appendTo: ".hub_filter_search_results"
    });
    $( ".js-hub-searchtext" ).on( "focus", function() {
        $(this).parent().addClass('active');
        return false;});
    $( ".js-hub-searchtext" ).on( "blur", function() {
        $(this).parent().removeClass('active');
        return false;});
    $( ".js-search-header-active input" ).on( "focus", function() {
        $(this).closest('.gsc-search-box').addClass('active');
        return false;});
    $( ".js-search-header-active input" ).on( "blur", function() {
        $(this).closest('.gsc-search-box').removeClass('active');
        return false;
    });

    //Check for a hash in the location, if there is one, adjust the scroll
    $(document).ready(function() {
    	var hash = window.location.hash;
    	if(hash){
    		$('html, body').stop(); //hopefully stop animation
    		handleAnchorTag($('a[name="'+ hash.replace('#','') +'"], a[id="'+ hash.replace('#','') +'"]').first());
    	}
    });

    /*smooth scroll for anchors*/
    $('.subpage_global_header a[href^="#"], .js-scroll-top[href^="#"],  .head_inner_second_line a[href^="#"], .global_header a[href^="#"], .rte.text a[href^="#"], .context-navigation__list-wrapper a[href^="#"]').on('click',function(){
        //ignore target and scroll to the top!
        if ($(this).hasClass('js-scroll-top')) {
            $.scrollTo($('div[name="'+ $(this).attr("href").substring(1) +'"]'), 1500, 'easeInOutExpo');
        }
        else {
        	handleAnchorTag($('a[name="'+ $(this).attr("href").substring(1) +'"], a[id="'+ $(this).attr("href").substring(1) +'"]').first());
        }
        return false;
    });
    /*smooth scroll for anchors for cta-button*/
    $('.cta-button a[href^="#"]').not('a[href^="#js-"]').on('click',function(){
        if ($(this).hasClass('js-scroll-top')) {
            $.scrollTo($('body[name="'+ $(this).attr("href").substring(1) +'"]'), 1500, 'easeInOutExpo');
        }
        else {
        	handleAnchorTag($('a[name="'+ $(this).attr("href").substring(1) +'"], a[id="'+ $(this).attr("href").substring(1) +'"]').first());
        }
        return false;
    });


    //Smooth scrolling for In page Nav (sticky nav) links
    $('.in_page_nav a.link[href^="#"]').on('click',function(event){
        handleAnchorTag($('a[name="'+ $(this).attr("href").substring(1) +'"], a[id="'+ $(this).attr("href").substring(1) +'"]').first());
        event.preventDefault();
    });

    //GENERIC FUNCTION TO HANDLE ANCHOR TAG SCROLLING
    //target is the html dom element that we want to scroll to
    function handleAnchorTag(scroll_target) {
        
        var total_offset = 76 ;
        var subsite_header_offset = 30;

        if ($(window).width() > 768 && $(".sub_site_header").length) {
            total_offset = total_offset + subsite_header_offset; // changed the offset as new header added.
        }
        
        // For pages with gdpr message.
        if ($('html, body').hasClass('gdpr-shown')) {
            var $guardedEl_gdpr_notification_co = $(".gdpr-notification__container:visible");
            if ($guardedEl_gdpr_notification_co.length) {
                var gdpr_height = $guardedEl_gdpr_notification_co.height();
                if(gdpr_height){
                    total_offset = total_offset + gdpr_height;
                }
            } else {
                console.warn('guard-jquery-calls: $(".gdpr-notification__container:visible") not found, skipping.');
            }
            
        }

        var notification = $('.cmp-flindersonline-notification');
        if (notification) {
            var notification_height = notification.height();
            if(notification_height){
                total_offset += notification_height;
            }
        }

        var in_page_nav = $('.in-page-nav');
        if (in_page_nav) {
            var in_page_nav_height = in_page_nav.height();
            if(in_page_nav_height){
                total_offset += in_page_nav_height;
            }
        }

        const reciteMeHeader = document.getElementById("recite-header");
        if(reciteMeHeader){
             total_offset += reciteMeHeader.offsetHeight;
        }

        if(scroll_target.data('parent') === "#accordion") {
            if(scroll_target.hasClass('collapsed')) {
                //This means the accordion for this header is closed
                scroll_target.click();
            }
        } else if(scroll_target.closest('.accordion-card').length == 1) {
            //the target is inside an accordion
            //This line will only click on the parent accordion header if it is collapsed, otherwise it does nothing.
            scroll_target.closest('.accordion-card').find(".accordion-card__header a[data-parent='#accordion'].collapsed").click();

        } else {
            scroll_target.addClass("d-block");
            total_offset = total_offset + 24; // 24 is line height.
        }
        $.scrollTo(scroll_target, 600, { offset: - total_offset });
        if (scroll_target.hasClass("d-block")) {
            scroll_target.removeClass("d-block");
        }

    }

    ////////////////////////////////////////
    /////Start content table pagination/////
    ////////////////////////////////////////

    var scroll_to_element = false;

    function contentTableInputPageChangeDelay(ctInput) {
        var val = $(ctInput).val();
        if(!$.isNumeric(val))return;
        var dynatable = $('#'+$(ctInput).attr('id').substr(0,$(ctInput).attr('id').indexOf("_pag_input_page"))).data('dynatable');
        var maxPage = Math.ceil(dynatable.settings.dataset.queryRecordCount / dynatable.settings.dataset.perPage);
        if(val>0&&val<=maxPage&&dynatable.settings.dataset.page!=val){
            //top = $(ctInput).offset().top - $(window).scrollTop();
            dynatable.paginationPage.set(val);
            dynatable.process();
           // $.scrollTo('#dynatable-search-'+dynatable.$element.attr('id'), 600, {  offset: -100 });
            scrollToContentTable('#dynatable-search-'+dynatable.$element.attr('id'));
        }
    }

    function scrollToContentTable(contentTableId) {
    	if(scroll_to_element) {
    		$.scrollTo(contentTableId, 600, {  offset: -130 });
    	}
    }

    function contentTableInputPageChange(ctInput) {
        if ($(this).data("timeout")) clearTimeout($(this).data("timeout"));
        $(this).data("timeout",setTimeout(function () {
            contentTableInputPageChangeDelay(ctInput);
        },1000));
    }

    function bindPaginationNavigation(dynatable){
        var currentPage = dynatable.settings.dataset.page;
        var maxPage = Math.ceil(dynatable.settings.dataset.queryRecordCount / dynatable.settings.dataset.perPage);
        $('.content-table-pagination-max-'+dynatable.settings.index_on_page).text(maxPage);
        $('#' + dynatable.$element.attr('id') + '_pag_input_page').val(currentPage);
        if(currentPage>1) {
            $('#' + dynatable.$element.attr('id') + '_pag_nav_prev').attr('data-dynatable-page', currentPage-1);
            $('#' + dynatable.$element.attr('id') + '_pag_nav_prev').show();
            $('#' + dynatable.$element.attr('id') + '_pag_nav_prev').on('click', function() {scrollToContentTable('#dynatable-search-'+dynatable.$element.attr('id'));});        
        }else{
            $('#' + dynatable.$element.attr('id') + '_pag_nav_prev').hide();
        }
        if(currentPage<maxPage) {
            $('#' + dynatable.$element.attr('id') + '_pag_nav_next').attr('data-dynatable-page', currentPage+1);
            $('#' + dynatable.$element.attr('id') + '_pag_nav_next').show();
            $('#' + dynatable.$element.attr('id') + '_pag_nav_next').on('click', function() {scrollToContentTable('#dynatable-search-'+dynatable.$element.attr('id'));});        
        }else{
            $('#' + dynatable.$element.attr('id') + '_pag_nav_next').hide();
        }
        var ev = $._data($('#' + dynatable.$element.attr('id') + '_pag_input_page').get(0), 'events');
        if(!ev || !ev.input)
        $('#' + dynatable.$element.attr('id') + '_pag_input_page').on('input',function(e){
            contentTableInputPageChange(this);
        });
    }
    function getContentTableSearchLabel(table) {
       var attr = table.attr('search_label');
       if (typeof attr !== typeof undefined && attr !== false) {
            if(attr.length>0)
                return attr;
            else
                return 'Search';
        }else{
            return 'Search'
        }
    }
    function setContentTableSearchAlign(table) {
        if(table.hasClass('table_search_left_align')){
            $('#dynatable-search-'+(table.attr('id'))).css("text-align","left");
        }
    }
    function setContentTableSearchHide(table) {
        var attr = table.attr('search_hide');
        if (typeof attr !== typeof undefined && attr !== false) {
            return false;
        }else{
            return true
        }
    }
    function addIconToContentTableSearch(table) {
        $('<a class="content-table-search-icon"><i class="material-icons"></i></a>').insertAfter('#dynatable-query-search-'+table.attr('id'));
    }
    function bindPaginatedTable(table, rows, index){
        table.bind('dynatable:init', function(e, dynatable) {
            dynatable.$element.find('.dynatable-sort-header:eq(0)').click(); //NOTE: This triggers the scroll
            $('.content-table-pagination-max-'+dynatable.settings.index_on_page).text(Math.ceil(dynatable.settings.dataset.queryRecordCount / dynatable.settings.dataset.perPage));
        }).dynatable({
            inputs: {
                queryEvent: 'blur change keyup',
                multisort: false,
                paginationLinkTarget: null,
                paginationLinkPlacement: 'after',
                paginationClass: 'dynatable-pagination-links media_hub_pagination pagination-links',
                paginationPrev: '',
                paginationNext: '',
                paginationGap: [1,2,2,1],
                pageText: 'Page <input class="js-pagination-current" id="'+table.attr('id')+'_pag_input_page" type="text" value="1" /> of <span class="content-table-pagination-max-'+index+' js-pagination-max content-table-pagination-max"></span><a href="javascript:void(0);" id="'+table.attr('id')+'_pag_nav_prev" title="" class="js-gallery-nav pag_yellow_button btn_left dynatable-page-link"></a> <a href="javascript:void(0);" id="'+table.attr('id')+'_pag_nav_next" title="" class="js-gallery-nav pag_yellow_button btn_right dynatable-page-link"></a>',
                searchText: getContentTableSearchLabel(table),
                processingText: 'Processing...'
            },
            features: {
                paginate: true,
                sort: true,
                search: setContentTableSearchHide(table),
                recordCount: false,
                perPageSelect: false,
                pushState: false,
                appendArrowUp:true
            },
            dataset:{
                ajax: false,
                perPageDefault: rows
            },
             index_on_page: index
        }).bind('dynatable:afterProcess', function(data){
            $(this).find('td').mark($('#dynatable-query-search-'+$(this).attr('id')).val());
            bindPaginationNavigation($(this).data('dynatable'));
        });
        $.when(table.dynatable()).done(function(table) {
            var dynatable = table.data('dynatable');
            bindPaginationNavigation(dynatable);
            setContentTableSearchAlign(table);
            addIconToContentTableSearch(table);
            scroll_to_element = true;
        });
        var ev = $._data($('#' + table.attr('id') + '_pag_input_page').get(0), 'events');
        if(!ev || !ev.input)
        $('#' + table.attr('id') + '_pag_input_page').on('input',function(e){
            contentTableInputPageChange(this);
        });
    };
    $('.table_sort_search_class').each(function (index, table) {
        if($(table).hasClass('table_search_pagination_25')){
            bindPaginatedTable($(table),25, index);
        }else if($(table).hasClass('table_search_pagination_50')){
            bindPaginatedTable($(table), 50, index);
        }else{
            $(table).bind('dynatable:init', function(e, dynatable) {
                dynatable.$element.find('.dynatable-sort-header:eq(0)').click();
            }).dynatable({
                inputs: {
                    queryEvent: 'blur change keyup',
                    multisort: false,
                    searchText: getContentTableSearchLabel($(table))
                },
                features: {
                    paginate: false,
                    sort: true,
                    search: setContentTableSearchHide($(table)),
                    recordCount: false,
                    perPageSelect: false,
                    pushState: false,
                    appendArrowUp:true
                }
            }).bind('dynatable:afterProcess', function(data){
                //$('#table_sort_search td').mark($('#dynatable-query-search-table_sort_search').val());
                $(this).find('td').mark($('#dynatable-query-search-'+$(this).attr('id')).val());

            });
            setContentTableSearchAlign($(table));
            addIconToContentTableSearch($(table));
        }

    });
    ////////////////////////////////////////
    //////End content table pagination//////
    ////////////////////////////////////////

    //parallax effect
     $('.parallax_section').parallax();

    //Detect iOS and apply iOS specific code
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
    	//Apply class to body tag for iOS-specific styles when needed
    	$('body').addClass("ios_device");
    	//Display jotform modal fallback (direct link to jotform) for iOS because iOS hates modals.
    	//the "d-block" class used for buttons has !important on it, which means just showing and hiding does not work
    	$('.jotform_modal_button').removeClass('d-block').hide();
    	$('.jotform_fallback_button').show();
    	//for fixed parallax
    	$('.fixed_parallax_section').addClass('fixed-parallax-ios');
	}

    //RTE styles plugin workaround for lists
    $(".rte ol li, .rte ul li").find("span[class^='text_color']:first", this).each(function () {
    	var currentSpan = $(this);
    	var firstNode = currentSpan.parent().contents()[0];
    	var nodeTypeText = 3;
    	//if the first node is "text" then do not apply the style to the list item i.e.
    	//"<li> Words here <span class="className">more words</span></li>" Will not add "className" to the li tag
    	//"<li><span class="className">more words</span> Words here</li>" *Will* add "className" to the li tag
    	if (firstNode.nodeType !== nodeTypeText){
    		if(currentSpan.hasClass('text_color_flinders_gold')){
            	currentSpan.parent().addClass('text_color_flinders_gold');
            }else if(currentSpan.hasClass('text_color_flinders_navy')) {
            	currentSpan.parent().addClass('text_color_flinders_navy');
            }else if(currentSpan.hasClass('text_color_flinders_white')) {
            	currentSpan.parent().addClass('text_color_flinders_white');
            }else if(currentSpan.hasClass('text_color_flinders_black')) {
            	currentSpan.parent().addClass('text_color_flinders_black');
            }else if(currentSpan.hasClass('text_color_flinders_light_grey')) {
            	currentSpan.parent().addClass('text_color_flinders_light_grey');
            }else if(currentSpan.hasClass('text_color_flinders_medium_grey')) {
            	currentSpan.parent().addClass('text_color_flinders_medium_grey');
            }else if(currentSpan.hasClass('text_color_flinders_dark_grey')) {
            	currentSpan.parent().addClass('text_color_flinders_dark_grey');
            }else if(currentSpan.hasClass('text_color_flinders_midnight_blue')) {
                currentSpan.parent().addClass('text_color_flinders_midnight_blue');
            }else if(currentSpan.hasClass('text_bg_color_flinders_gold')) {
            	currentSpan.parent().addClass('text_bg_color_flinders_gold');
            }else if(currentSpan.hasClass('text_size_large')) {
            	currentSpan.parent().addClass('text_size_large');
            }else {
            	//do nothing
            }
    	}
    });

    //cta buttom alignment
    $('p.component_section_d1').each(function () {
        if($(this).parent().hasClass('cta-button')){
            if($(this).hasClass('cta_text_alignment_left'))
                $(this).parent().css("text-align", 'left');
            else if($(this).hasClass('cta_text_alignment_centre'))
                $(this).parent().css("text-align", 'center');
            else if($(this).hasClass('cta_text_alignment_right'))
                $(this).parent().css("text-align", 'right');
        }
    })

    // Start - Tippy for rte tooltip.
    var tooltips = $('.rteTooltip');
    tooltips.each(function(index, element) {
        tippy(element, {
            allowHTML: true,
            trigger: 'mouseenter click',
            arrow: true,
            theme: 'flinders-sand',
            interactive: true,
            appendTo: document.body,
        });
    });
    // Start - Tippy for rte tooltip.
    var tooltips = $('.fast-facts-tooltip');
    tooltips.each(function(index, element) {
        tippy(element, {
            allowHTML: true,
            trigger: 'mouseenter click',
            arrow: true,
            theme: 'flinders-navy',
            interactive: true,
            appendTo: document.body,
        });
    });
    // End - Tippy for rte tooltip.

});

$(".course_list_component .item_heading").on("click" , function(e) {
	e.preventDefault();
	var all_accordion_items = $(this).closest('.accordion_container').children('.accordion_item');
	var current_accordion_item = $(this).closest('.accordion_item');

	if(current_accordion_item.hasClass('open')) {
		all_accordion_items.removeClass('open');
		all_accordion_items.children('.item_content').slideUp(750);
	} else {
		all_accordion_items.removeClass('open');
		all_accordion_items.children('.item_content').slideUp(750);
		current_accordion_item.addClass('open');
		current_accordion_item.children('.item_content').slideDown(750);
	}
});

function getAllQueryStringParams(){
    var Result = {};
    if(document.location.search){
        var searchString = document.location.search.replace(/^\?/,'');
        var params = searchString.split('&');
        for(var index = 0; index< params.length; index++){
            var keyValue = params[index].split('=');
            if(keyValue.length == 2){
                var key = keyValue[0];
                var value = keyValue[1];
                Result[key] = decodeURIComponent(value);
            }
        }
    }
    return Result;
}
/*
UTILITY FUNCTION
    Fade elements in one after another (as opposed to all at once)
requires:
    jQuery fadeIn() - https://api.jquery.com/fadeIn/
accepts:
    duration (int) - the duration each individual element takes to complete their fadeIn() transition
    elements_array (array) - an array of jquery elements. NOTE: not a jQuery set of elements
example:
    fadeInRecursive(150,$.makeArray($(".pickle")));
*/
function fadeInRecursive(duration, elements_array){
    if (elements_array) {
        $(elements_array.shift()).fadeIn(duration,function() {
            fadeInRecursive(duration, elements_array)
        });
    }
}

/*
UTILITY FUNCTION
    Fade elements in one after another (as opposed to all at once) when elements are visually hidden using opacity.
requires:
    jQuery fadeTo() - https://api.jquery.com/fadeto/
accepts:
    duration (int) - the duration each individual element takes to complete their fadeTo() transition
    finalOpacity - the opacity value between 0 and 1 (inclusive) for the fadeTo transition to finish at, this will almost always be 1
    elements_array (array) - an array of jquery elements. NOTE: not a jQuery set of elements
example:
    fadeToRecursive(150, 1, $.makeArray($(".pickle")));
*/
function fadeToRecursive(duration, finalOpacity, elements_array) {
    if (elements_array) {
        $(elements_array.shift()).fadeTo(duration, finalOpacity, function () {
            fadeToRecursive(duration, finalOpacity, elements_array);
        });
    }
}
/*
UTILITY FUNCTION
    Provided a jQuery set of elements and the method for calculating height, returns the height of the tallest element.
requires:
    jQuery height() - https://api.jquery.com/height/
    jQuery innerHeight() - https://api.jquery.com/innerHeight/
    jQuery outerHeight() - https://api.jquery.com/outerHeight/
    jQuery each() - https://api.jquery.com/each/
accepts:
    elements (jQuery set) - jquery elements i.e. the result of a jQuery selector
    calculation_method (string) - the method for calculating height, expected values 'inner' 'outer' 'outer-all' any other value will be default'
returns:
    max_height (int) - the height of the tallest element.
example:
    getMaxHeightOfElements($(".pickle"));
*/
function getMaxHeightOfElements(elements, calculation_method) {
    var max_height = 0;
    switch (calculation_method) {
        case 'inner':
            //.innerHeight() - includes: element height, padding; excludes: border, margin
            $(elements).each(function () {
                if ($(this).innerHeight() > max_height) {
                    max_height = $(this).innerHeight();
                }
            });
            break;
        case 'outer':
            //.outerHeight() - includes: element height, padding, border; excludes: margin
            $(elements).each(function () {
                if ($(this).outerHeight() > max_height) {
                    max_height = $(this).outerHeight();
                }
            });
            break;
        case 'outer-all':
            //.outerHeight(true) - includes: element height, padding, border, margin
            $(elements).each(function () {
                if ($(this).outerHeight(true) > max_height) {
                    max_height = $(this).outerHeight(true);
                }
            });
            break;
        default:
            //.height() - includes: element height; excludes: padding, border, margin
            $(elements).each(function () {
                if ($(this).height() > max_height) {
                    max_height = $(this).height();
                }
            });
    }

    return max_height;
}

/*
UTILITY FUNCTION
    Provided an array of element ID's and their immediate parent container, attempts to re-order the matching elements based on the order of the array.
        - if any elements in the parent container do not match the elements in the array, they will keep their order but be listed after all array elements.
        - if parent_container matches multiple, elements will be cloned instead of moved, not what we want in this case but someone might want that!
requires:
    jQuery prepend() - https://api.jquery.com/prepend/
accepts:
    array_of_ids (array) - an array of DOM element ID's
    parent_container (jQuery) - a jQuery element that ideally contains the elements to be ordered
example:
    sortDomElementsById(["pickle_1","pickle_2"], $("#pickle"));
*/
function sortDomElementsById(array_of_ids, parent_container) {
    // Note(JD) - Using pop() here because we are prepending to the parent.
    // If we just looped through the array and prepended, the last item in the array would appear first.
    // If we appended instead, then elements not in the array will appear first (which we don't want in this case)
    while (array_of_ids.length) {
    	var element = parent_container.find("#" + array_of_ids.pop());
    	parent_container.prepend(element);
    }
}


// YouTube video autoplay using the overlay/button.
// This will automatically makes the YouTube video plays, and button will be removed right after.
// Button will appear again once the page refreshed.
jQuery(document).ready(function () {
    $(document).on('click', '.video-overlay-wrapper, .custom-play-button, .video-image-overlay', function () {
        const videoContainer = $(this).closest('.video');

        const overlay = videoContainer.find('.video-overlay-wrapper');
        if (!overlay.hasClass('no-fade-out')) {
            overlay.fadeOut();
        }

        const videoImage = videoContainer.find('.video-image-overlay');
        videoImage.fadeOut();

        const iframe = videoContainer.find('iframe');
        if (iframe.length) {
            const src = iframe.attr('src');
            if (src && !src.includes('autoplay=1')) {
                const newSrc = src.includes('?')
                    ? src + '&autoplay=1'
                    : src + '?autoplay=1';
                iframe.attr('src', newSrc.replace('autoplay=0', 'autoplay=1'));
            }
        }
    });
});

function escapeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function sanitizeUrl(url) {
    if (!url) return '#';

    try {
        const parsed = new URL(url, window.location.origin);
        const allowedProtocols = ['http:', 'https:'];

        if (!allowedProtocols.includes(parsed.protocol)) {
            return '#';
        }

        return parsed.href;
    } catch (e) {
        return '#';
    }
}
